/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { DefaultButton } from '@fluentui/react/lib/Button';
import { CustomizerContext } from '@fluentui/react/lib/Utilities';
import * as React from 'react';

import { getAppHost } from '../../../utilities/TeamsUtils';
import { TemplateIcon, TemplateIconProps } from '../../common/TemplateIcon/TemplateIcon.component';
import { getButtonStyles, getIconStyles } from './SelectableButton.styles';

export interface SelectableButtonProps {
    title: string;
    description: string;
    id: string;
    imageSrc: string;
    onSelected?: (id: string) => void;
}

export const SelectableButton: React.FC<SelectableButtonProps> = (props: SelectableButtonProps): JSX.Element => {
    const { title, description, id, onSelected, imageSrc } = props;
    const theme = React.useContext(CustomizerContext).customizations.settings.theme;
    const themeName = getAppHost().getTheme();

    const iconProps: TemplateIconProps = {
        imageSrc,
        title,
        description,
    };

    return (
        <DefaultButton
            onClick={(): void => {
                onSelected(id);
            }}
            styles={getButtonStyles(theme, themeName)}
            className='selectable-button-container'>
            <TemplateIcon styles={getIconStyles()} {...iconProps} />
        </DefaultButton>
    );
};
